'use client';

import { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import type { Surface } from '@frameio/connected-surfaces-core/messaging';
import { ConnectedSurfacesContext } from '../contexts/ConnectedSurfacesContext';

export const useIsDriveConnected = () =>
  useContextSelector(
    ConnectedSurfacesContext,
    (value) => value.isDriveConnected
  );

export const useSendConnectedSurfaceMessage = () =>
  useContextSelector(
    ConnectedSurfacesContext,
    (value) => value.sendSurfaceMessage
  );

export const useSendConnectedSurfaceRequest = () =>
  useContextSelector(
    ConnectedSurfacesContext,
    (value) => value.sendSurfaceRequest
  );

export const useSubscribeConnectedSurfaceMessage = () =>
  useContextSelector(
    ConnectedSurfacesContext,
    (value) => value.subscribeSurfaceMessage
  );

export function useConnectedSurfaceMessagingStatus(destination: Surface) {
  const isReady = useContextSelector(ConnectedSurfacesContext, (value) =>
    value.messagingStatus.readySurfaces.includes(destination)
  );
  const sessionKey = useContextSelector(
    ConnectedSurfacesContext,
    (value) => value.messagingStatus.sessionKey
  );
  return useMemo(() => ({ isReady, sessionKey }), [isReady, sessionKey]);
}
